import './styles/gameIntroDialog.css';
import Dialog from '../../subcomponents/Dialog';
import { useGameStore } from '../../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import Tile from '../../subcomponents/Tile';
import { getBonusLetter } from '../../utils/nextLetterHelper';
import { GameMode } from '@/types/types';
import { getDayNumber } from '../../utils/dayCounterHelper';

type GameIntroDialogProps = {
  open: boolean;
  onClose: () => void;
};

function GameIntroDialog(props: GameIntroDialogProps) {
  const { open, onClose } = props;

  // Subscribe to game store
  const { mode } = useGameStore(
    useShallow((state) => ({
      mode: state.mode,
    }))
  );

  const getTitle = () => {
    switch (mode) {
      case 'blitzSimple':
        return '4x4 BLITZ';
      case 'blitzDeluxe':
        return '5x5 BLITZ';
      case 'endlessSimple':
        return '4x4 ENDLESS';
      case 'endlessDeluxe':
        return '5x5 ENDLESS';
    }
  };

  type GameDetail = {
    wordLength: number;
    minutes: number | null;
    swaps: number;
    timeAdded: number | null;
  };

  const gameDetails: Record<GameMode, GameDetail> = {
    blitzSimple: { wordLength: 4, minutes: 3, swaps: 5, timeAdded: 3 },
    blitzDeluxe: { wordLength: 5, minutes: 5, swaps: 8, timeAdded: 5 },
    endlessSimple: { wordLength: 4, minutes: null, swaps: 5, timeAdded: null },
    endlessDeluxe: { wordLength: 5, minutes: null, swaps: 8, timeAdded: null },
  };

  const blitzIntro = (
    <>
      Create as many <b>{gameDetails[mode].wordLength}-LETTER</b> words as possible within{' '}
      <b>{gameDetails[mode].minutes} MINUTES</b> given <b>{gameDetails[mode].swaps} SWAPS</b>. Each
      word will add <b>{gameDetails[mode].timeAdded} SECONDS</b> to the timer.
    </>
  );

  const endlessIntro = (
    <>
      Create as many <b>{gameDetails[mode].wordLength}-LETTER</b> words as possible given{' '}
      <b>{gameDetails[mode].swaps} SWAPS</b>.
    </>
  );

  return (
    <Dialog open={open} onClose={onClose} title={getTitle()}>
      <div className="game-intro-container">
        <div className="game-intro-description">
          {mode.includes('blitz') && blitzIntro}
          {mode.includes('endless') && endlessIntro}
        </div>
        <div className="flex items-center gap-2">
          <div className="game-intro-bonus-text">
            Today's <b>BONUS</b> letter:
          </div>
          <Tile value={getBonusLetter()} small bonus />
        </div>

        <div className="daily-game-text">Daily LetterSwap #{getDayNumber()}</div>
      </div>
    </Dialog>
  );
}

export default GameIntroDialog;
